import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ITag, ITagInput } from "@/interfaces/tag.interface";
import tagService from "@/services/tag.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateTagProps = {
  formData: ITagInput;
} & RequestsProps;

export type UseCreateTagReturn = {
  create: (props: CreateTagProps) => Promise<ITag>;
} & UseLoadingReturn;

const useCreateTag = (): UseCreateTagReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<ITagInput>({
    operation: (formData) => tagService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateTag;
